import type { CSSProperties } from 'react'
import React, { forwardRef } from 'react'
import { Icons } from '../../../assets/icons'
import { ValuePicto } from '../../../components/ValuePicto'
import { Assignation } from '../../../context/types'
import {
    fluidM,
    fluidSM,
    fluidXS,
    fluidXXS,
    fluidXXXS,
} from './fluidFonts'
import { debugStm } from '../lib/utils'
import { useTheme } from '@mui/material'
import { isMobileAll } from '../../../utils'

export interface RankingStmProps {
    stm: Assignation
    withIcon?: boolean
    style?: CSSProperties
    debug?: boolean
    compact?: boolean
    landscape?: boolean
    withinScrollFix?: boolean
}

export const RankingStm = forwardRef<HTMLDivElement, RankingStmProps>(({
    stm,
    withIcon = true,
    debug = false,
    compact = false,
    landscape = false,
    withinScrollFix = false,
    style,
    ...props
}, ref) => {
    const muiTheme = useTheme()

    let fontSizeStyle: CSSProperties
    if (compact) {
        if (isMobileAll()) {
            fontSizeStyle = landscape ? fluidXS : fluidSM
        } else {
            fontSizeStyle = fluidXXXS
        }
    } else {
        fontSizeStyle = fluidM
    }
    fontSizeStyle = {
        ...fontSizeStyle,
        // FIXME why not automatic ?
        color: muiTheme.palette.text.primary,
    }

    return (
        <div
            ref={ref}
            style={{
                ...style,
                backgroundColor: muiTheme.palette.background.default,
            }}
            // TODO Bang is css important to keep, otherwise it's overwritten by the parent
            className="cursor-pointer !rounded !p-1 flex items-center justify-between gap-1"
            data-testid={`RankingStm`}
            {...props}
        >
            <div className="flex w-full items-center justify-between gap-1">
                <div className="flex flex-row items-center gap-2">
                    {withIcon && (
                        <ValuePicto 
                            valueKey={stm.valueKey} 
                            iconSizePreset={compact ? 'compact' : isMobileAll() ? 'normal' : 'medium'}
                        />
                    )}
                    <span style={fontSizeStyle}>
                        {debug && (
                            <span
                                style={{
                                    ...fluidXXS,
                                    marginRight: 2,
                                }}
                            >{`${debugStm(stm)}`}</span>
                        )}
                        {stm.title}
                    </span>
                </div>

                {!compact && <Icons.DragIcon
                    sx={{
                        fontSize: isMobileAll() ? '1.5rem' : '2rem',
                        opacity: '0.5',
                    }}
                />}
            </div>
        </div>
    )
})